function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
import React, { useState, useEffect } from "react";
import { Form, Input, Button, Select, InputNumber, Space, message, Alert } from "antd";
import Common from "../includes/Common";
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
var EditCompany = function EditCompany(_ref) {
  var company = _ref.company,
    handler = _ref.handler;
  var _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    isFormLoading = _useState2[0],
    setIsFormLoading = _useState2[1];
  var _useState3 = useState(''),
    _useState4 = _slicedToArray(_useState3, 2),
    formError = _useState4[0],
    setFormError = _useState4[1];
  var _useState5 = useState(''),
    _useState6 = _slicedToArray(_useState5, 2),
    formSuccess = _useState6[0],
    setFormSuccess = _useState6[1];
  var _useState7 = useState([]),
    _useState8 = _slicedToArray(_useState7, 2),
    insurers = _useState8[0],
    setInsurers = _useState8[1];
  var _Form$useForm = Form.useForm(),
    _Form$useForm2 = _slicedToArray(_Form$useForm, 1),
    form = _Form$useForm2[0];
  var onFinish = function onFinish(values) {
    setIsFormLoading(true);
    setFormError('');
    setFormSuccess('');
    var formData = new FormData();
    formData.append('label', values.label);
    formData.append('address', values.address);
    formData.append('telephone', values.telephone);
    formData.append('email', values.email);
    formData.append('email_1', values.email_1);
    formData.append('email_2', values.email_2);
    formData.append("short_name", values.short_name);
    axios.post(Common.baseApiUrl + 'editcompany', formData).then(function (response) {
      if (response.data.status == 200) {
        setFormSuccess('Opération réussie');
        handler();
      } else {
        setFormError(response.data.message);
      }
    })["catch"](function (error) {
      setFormError('Une erreur est survenue');
    })["finally"](function () {
      setIsFormLoading(false);
    });
  };
  useEffect(function () {
    if (company == null) return;
    form.setFieldsValue({
      label: company.label,
      short_name: company.short_name,
      email: company.email,
      email_1: company.email_1,
      activity: company.activity,
      email_2: company.email_2,
      address: company.address,
      telephone: company.telephone
    });
  }, []);
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [formError.length > 0 && /*#__PURE__*/_jsx(Alert, {
      type: "error",
      message: formError,
      showIcon: true
    }), formSuccess.length > 0 && /*#__PURE__*/_jsx(Alert, {
      type: "success",
      message: formSuccess,
      showIcon: true
    }), /*#__PURE__*/_jsxs(Form, {
      form: form,
      layout: "vertical",
      onFinish: onFinish,
      children: [/*#__PURE__*/_jsx(Form.Item, {
        name: "label",
        label: "Nom complet",
        rules: [{
          required: true,
          message: 'Ce champs est obligatoire'
        }],
        children: /*#__PURE__*/_jsx(Input, {})
      }), /*#__PURE__*/_jsx(Form.Item, {
        name: "short_name",
        label: "Nom court",
        rules: [{
          required: true,
          message: 'Ce champs est obligatoire'
        }],
        children: /*#__PURE__*/_jsx(Input, {})
      }), /*#__PURE__*/_jsx(Form.Item, {
        name: "email",
        label: "E-mail (RH)",
        children: /*#__PURE__*/_jsx(Input, {})
      }), /*#__PURE__*/_jsx(Form.Item, {
        name: "email_1",
        label: "E-mail (FACTURATION)",
        children: /*#__PURE__*/_jsx(Input, {})
      }), /*#__PURE__*/_jsx(Form.Item, {
        name: "email_2",
        label: "E-mail (COMMERCIAL)",
        children: /*#__PURE__*/_jsx(Input, {})
      }), /*#__PURE__*/_jsx(Form.Item, {
        name: "address",
        label: "Adresse",
        children: /*#__PURE__*/_jsx(Input, {})
      }), /*#__PURE__*/_jsx(Form.Item, {
        name: "telephone",
        label: "T\xE9l\xE9phone",
        children: /*#__PURE__*/_jsx(Input, {})
      }), /*#__PURE__*/_jsx(Form.Item, {
        name: "activity",
        label: "Secteur d'activi\xE9",
        children: /*#__PURE__*/_jsx(Select, {
          options: [{
            value: "BTP/Mines et carrieres",
            label: "BTP/Mines et carrieres"
          }, {
            value: "Machines / Equipement / Automobile",
            label: "Machines / Equipement / Automobile"
          }, {
            value: "Metallurgie / Plastique / Chimie",
            label: "Metallurgie / Plastique / Chimie"
          }, {
            value: "Hydrocarbures / Gaz / Hydro-énergie",
            label: "Hydrocarbures / Gaz / Hydro-énergie"
          }, {
            value: "Industries / Transport / Logistique",
            label: "Industries / Transport / Logistique"
          }, {
            value: "Bois / Papier / Carton / Imprimerie",
            label: "Bois / Papier / Carton / Imprimerie"
          }, {
            value: "Télécommunication / Internet",
            label: "Télécommunication / Internet"
          }, {
            value: "Banques / Assurances / Cabinet d'audit / Etude et conseil",
            label: "Banques / Assurances / Cabinet d'audit / Etude et conseil"
          }, {
            value: "Hotellerie / Tourisme / Restauration",
            label: "Hotellerie / Tourisme / Restauration"
          }, {
            value: "Commerce / Négoce / Distribution",
            label: "Commerce / Négoce / Distribution"
          }, {
            value: "Education / Santé / Hygiène / Sécurité / Administration publique / Action sociale",
            label: "Education / Santé / Hygiène / Sécurité / Administration publique / Action sociale"
          }, {
            value: "Hopitaux et structures de soins médicaux",
            label: "Hopitaux et structures de soins médicaux"
          }]
        })
      }), /*#__PURE__*/_jsx(Form.Item, {
        children: /*#__PURE__*/_jsx(Button, {
          htmlType: "submit",
          loading: isFormLoading,
          type: "primary",
          children: /*#__PURE__*/_jsx("b", {
            children: "Sauvegarder"
          })
        })
      })]
    })]
  });
};
export default EditCompany;